/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAward: {
  name: 'award';
  data: string;
} = {
  name: 'award',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm-.161 4.322a6 6 0 1 1 8.323 0l2.787 8.362a1 1 0 0 1-1.396 1.21L12 19.118l-5.553 2.776a1 1 0 0 1-1.396-1.21l2.788-8.362Zm1.72 1.161-1.847 5.543 3.84-1.92a1 1 0 0 1 .895 0l3.84 1.92-1.847-5.543A5.979 5.979 0 0 1 12 14a5.979 5.979 0 0 1-2.44-.517Z" fill="currentColor"/></svg>`,
};
